// extracted by mini-css-extract-plugin
export default {"zerone-loader":"ZeroneLoader_zerone-loader__wpslj","loading-text":"ZeroneLoader_loading-text__Gf53U","bounce":"ZeroneLoader_bounce__ZbbNI"};